var uploadFMVar;
var uploadManager;
var indexSocial = [];
document.addEventListener("DOMContentLoaded", function(){
    'use strict';
    window.addEventListener('image:upload', function(){
        uploadFMVar.show();
    });
    window.addEventListener('logo:upload', function(){
        uploadFMVar.showLogos();
    });
    uploadManager = new ImageBarManager({
        thumbContainer : document.querySelector("[data-type=thumbnails]"),
        thumbContainerLogos: document.querySelector("[data-type=logos]"),
        logosUploadProgress: document.querySelector('label[for="tab-3"] .upload_progress'),
        onImageDropOnContainer : function(evt){
            if (evt.dataTransfer.types) {
                if(evt.dataTransfer.types.indexOf('Files') !== -1 && evt.dataTransfer.types.indexOf('data') === -1) {
                    uploadFMVar.show();
                }
            }
        },
        onImageDelete : function (evt) {
            var image = evt.target.parentNode.getAttribute('data-uuid');
            var imageId = evt.target.parentNode.getAttribute('data-imageid');
            swal({
                title : Locale.get('confirm'),
                text : Locale.get('Uploader.confirms.delete_image'),
                icon : 'info',
                buttons : [
                    Locale.get('Uploader.cancel'),
                    "Ok"
                ]
            }).then(function(value) {
                if ( value ){
                    var thumbCont = document.querySelector("[data-uuid='"+image+"']");
                    var loader = thumbCont.querySelector('.loader');
                    var preview = thumbCont.querySelector(".preview");
                    loader.style.display = "block";
                    preview.classList.add("opacity30");
                    uploadFMVar.deleteImage(imageId,image);
                }
            });
        }
    });
    uploadFMVar = new GS.ImageUploader({
        'signature' : wallartProject.signature,
        'dID' : wallartProject.id,
        'logosUploadProgress': document.querySelector('label[for="tab-3"] .upload_progress'),
        'customer' : (window.getCustomerCode) ? window.getCustomerCode() : wallartProject.customer || "0",
        'backgroundUpload' : true,
        'uploadProgress' : function(uploaded,total, type){
            var progressContainer;
            //console.warn('CURRENT UPLOAD TYPE: %s. PROGRESS: %s', type, Math.round( (uploaded / total ) * 100), this);
            switch(type){
                case 'logos':
                    progressContainer = document.querySelector('label[for="tab-3"] .upload_progress');
                    if(!progressContainer) progressContainer = document.querySelector('.upload_progress');
                    break;
                default:
                    progressContainer = document.querySelector('.upload_progress');
                    break;
            }
            progressContainer.innerHTML = " ( "+Locale.get('Uploader.uploading').capitalize()+" : "+Math.round( (uploaded / total ) * 100)+" %)";
        },
        'uploadStart' : function(files, type) {
            console.warn('UPLOAD START: %s', type);
            if(typeof uploadManager !== 'undefined'){
                uploadManager.addImagesToUserImages(files, type);

            }
            this.hide();
        },
        'imageUploadStart' : function(uuid, type) {
            if(typeof uploadManager !== 'undefined'){
                uploadManager.createThumbnail(uuid, false, type);
                //resize();
            }
        },
        'imageUploadComplete' : function(uuid, type){
            if(typeof uploadManager !== 'undefined'){
                uploadManager.setUploadStatus(uuid,"upload_complete", type);
            }
        },
        'uploadComplete' : function(type) {
            this.hide();
            var progressContainer;
            console.warn('UPLOAD %s COMPLETE', type);
            switch(type){
                case 'logos':
                    progressContainer = document.querySelector('label[for="tab-3"] .upload_progress');
                    if(!progressContainer) progressContainer = document.querySelector('.upload_progress');
                    break;
                default:
                    progressContainer = document.querySelector('.upload_progress');
                    break;
            }
            progressContainer.innerHTML = " ( "+Locale.get('Uploader.waiting_preview_generation') +" )";
            //document.querySelector('.images_cont #thumbnails')
        },
        'uploadCompleteWithErrors' : function(errors,success){
            if(success == 0) {
                swal({
                    'title' : 'Error',
                    'icon' : 'error',
                    'text' : Locale.get('Uploader.errors.error_all_files')
                });
            } else {
                var fileString = errors.map(function(obj){
                    return(obj.name);
                }).join(',');
                swal({
                    'title' : 'Error',
                    'icon' : 'error',
                    'text' : Locale.get('Uploader.errors.completed_with_errors').replace('{fileString}',fileString)
                });
            }
        },
        'fileUploadError' : function(uuid) {
            if ( typeof uploadManager !== "undefined"){
                uploadManager.removeThumbnail(uuid);
            }
        },
        'imageReady' : function(imageData, type) {
            var use, el, els, thumbs, progressContainer;
            console.warn('IMAGE IS READY...GETTING THUMBNAIL', imageData, type);

            switch(type){
                case 'logos':
                    use = uploadManager.userLogoImages;

                    progressContainer = document.querySelector('label[for="tab-3"] .upload_progress');

                    if(!progressContainer) progressContainer = document.querySelector('.upload_progress');
                    break;
                default:
                    use = uploadManager.userImages;
                    progressContainer = document.querySelector('.upload_progress');
                    break;
            }
            if(use) {
                //Check for an already stored image_id...if any!
                use.some(function(img){
                    if(img && img.uuid === imageData.uuid) imageData.afterImportAction = img.afterImportAction || 'none';
                    if(img && !imageData.image_id && img.uuid === imageData.uuid && img.image_id) {
                        imageData.image_id = img.image_id;
                        if(img.originalName) imageData.original_name = img.originalName;

                    }
                    return (img && img.uuid === imageData.uuid);
                });
            }

            el = {
                image_id : imageData.image_id,
                uuid : imageData.uuid,
                src : window.cloudUploaderUrl+"/api/get_image/thumbs/"+imageData.image_id,
                width : imageData.width || null,
                height : imageData.height || null,
                original_name: imageData.original_name,
                afterImportAction : imageData.afterImportAction || 'none',
                type: type || 'default'
            };
            console.warn(el);
            uploadManager.addToLoadingQueue(el);
            els = document.querySelectorAll("[data-image_status='upload_complete']");
            thumbs = document.querySelectorAll(".thumbnail");
            if(els.length == thumbs.length){
                //var progressContainer = document.querySelector('.upload_progress');
                //progressContainer.innerHTML = "";
            }
        },
        'imageDeletionCompleted' : function(uuid,status) {
            if(status){
                uploadManager.removeThumbnail(uuid);
            } else {
                console.log("uhm status è false");
            }
            // TODO inserire codice per gestire il fallimento della cancellazione dell'immagine
        }
    });

    uploadFMVar.getImages().then(function(json){
        var tImages;
        tImages = document.getElementById('total_images');
        uploadManager.userImages = json;
        /*uploadManager.onQueueEmpty = function(){
            console.info('ALL IMAGES READY');
        };*/
        //document.getElementById('total_images').innerHTML = json.length;
        json.forEach(function(el){
            uploadManager.createThumbnail(el.uuid,true, 'default');
            el.src = window.cloudUploaderUrl+"/api/get_image/thumbs/"+el.image_id;
            uploadManager.addToLoadingQueue(el,true, 'default');
        });
        if(tImages) tImages.innerHTML = json.length;
        uploadManager.resize();
    }).catch(function(error){
        console.error(error.message);
    });

    if(uploadManager && uploadManager.options.thumbContainerLogos) {
        uploadFMVar.getLogosImages().then(function(json){
            //console.warn('LOGOS IMAGES', json);
            var tImages;
            uploadManager.userLogoImages = json;
            tImages = document.getElementById('logos_total_images');
           // document.getElementById('logos_total_images').innerHTML = json.length;
            json.forEach(function(el){
                uploadManager.createThumbnail(el.uuid,true, 'logos');
                el.src = window.cloudUploaderUrl+"/api/get_image/thumbs/"+el.image_id;
                uploadManager.addToLoadingQueue(el,true, 'logos');
            });
            if(tImages) tImages.innerHTML = json.length;
            uploadManager.resize();
        }).catch(function(error){
            console.error(error.message);
        });
    }else{
        console.warn('[LOGOS IMAGES]: NO CONTAINER FOUND... SKIPPING!');
    }

    /*uploadFMVar.getLayoutsImages().then(function(json){
        //console.warn('LOGOS IMAGES', json);
        uploadManager.userLayoutsImages = json;
        document.getElementById('layouts_total_images').innerHTML = json.length;
        json.forEach(function(el){
            uploadManager.createThumbnail(el.uuid,true, 'layouts');
            el.src = window.cloudUploaderUrl+"/api/get_image/thumbs/"+el.image_id;
            uploadManager.addToLoadingQueue(el,true, 'layouts');
        });
        uploadManager.resize();
    }).catch(function(error){
        console.error(error.message);
    });*/
});
